import script from "./UsersAndPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersAndPermissions.vue?vue&type=script&setup=true&lang=js"

import "./UsersAndPermissions.vue?vue&type=style&index=0&id=55c382a2&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c382a2"]])

export default __exports__